import Backbone from 'backbone'
import $ from 'jquery'
import _ from 'lodash'
import mobile from 'scoreboard/components/mobile'
// Additional height compensation for stacked mobile dialog footer buttons
const STACKED_FOOTER_EXTRA_HEIGHT = 50

var ScrollingDialogTable = Backbone.View.extend({

	/**
 	 * The scrolling-dialog-table component sets a max-height on a table that should
	 * receive both x and y scrolling instead of needing to scroll the dialog to see
	 * its content.
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {jQuery|Element} options.el The element containing the scrollable table
	 *
	 * @param {Array} options.siblings An array of sibling elements that don't
	 * have a static height
	 *
	 * @param {Number} options.staticElementsHeight Fixed heights that need to be compensated
	 * for when calculating the max-height of the table. This can include siblgins
	 * with fixed heights and padding/margins of the dialog.
	 */

	initialize: function(options) {
		this.options = options || {}
		_.bindAll(this, 'resizePanel')
	},

	render: function() {
		this.resizePanel()
		$(window).on('resize', this.resizePanel)
		this.$el.css('overflow-y', 'auto')
		return this
	},

	resizePanel: function() {
		if (!this.body) this.body = $('body') // cache for window resizing
		let nonStaticSiblingsHeight = 0
		_.forEach(this.options.siblings, el => {
			nonStaticSiblingsHeight += el.height()
		})
		// Static elements height includes elements that don't wrap so their heights
		// are always consistent. Also includes padding and margins.
		let staticElementsHeight = mobile.isMobileOrientation() ?
			this.options.staticElementsHeight + STACKED_FOOTER_EXTRA_HEIGHT :
			this.options.staticElementsHeight
		let totalSiblingsHeight = nonStaticSiblingsHeight + staticElementsHeight
		let tableHeight = this.body.height() - totalSiblingsHeight
		this.$el.css('max-height', tableHeight + 'px')
	},

	remove() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.porter], 'remove')
		$(window).off('resize', this.resizePanel)
	}

})

export default ScrollingDialogTable


ScrollingDialogTable.__filename__ = 'components/scrolling-dialog-table.js'
